import { BaseWidget } from 'models/WidgetModel';
import React, { useEffect, useState } from 'react';
import './IndividualMetric.scss';

const IndividualMetric: React.FC<BaseWidget> = ({ response }) => {
  const [metric, setMetric] = useState<string>();

  useEffect(() => {
    if (response) {
      if (response?.data?.data?.length) {
        setMetric(response.data.data[0].value);
      }
    }
  }, [response]);

  return (
    <div className="individual-metric">
      <div className="metric-value">{metric}</div>
    </div>
  );
};

export default IndividualMetric;
